import React from 'react';
import PropTypes from 'prop-types';
import s from './Navigation.css';

/**
 * Composant de menu de navigation
 * Affiche un menu avec ses options
 * 
 * @param {Object} props - Props du composant
 * @param {string} props.menuKey - Clé unique du menu
 * @param {string} props.menuOpened - Clé du menu actuellement ouvert
 * @param {Object} props.title - Titre du menu avec icône et label
 * @param {string} props.link - Lien du menu principal
 * @param {Array} props.options - Options du menu
 * @param {Function} props.handleMenu - Handler pour les clics sur le menu
 * @returns {JSX.Element} Composant NavigationMenu
 */
const NavigationMenu = ({ 
  menuKey, 
  menuOpened, 
  title, 
  link, 
  options, 
  handleMenu 
}) => {
  /**
   * Gère les clics sur le menu
   */
  const handleClick = (e, optionLink, optionFct) => {
    if (handleMenu) {
      handleMenu(e, menuKey, optionLink, optionFct);
    }
  };

  // Génération des options du menu
  const menuOptions = options ? options.map(option => {
    const optionIcon = option.icon ? option.icon : <></>;
    return (
      <li 
        className={`${option.className ? option.className + " " : ""}${s.link}`} 
        key={`option_${option.label}`}
      >
        <div onClick={e => handleClick(e, option.link, option.fct)}>
          {optionIcon}
          <span>{option.label}</span>
        </div>
      </li>
    );
  }) : [];

  const menuIcon = title.icon ? title.icon : <></>;
  const isMenuOpen = menuOpened === menuKey;

  return (
    <div 
      className={`${s.menu}${isMenuOpen ? " " + s.navMenuShow : ""}`} 
      onClick={e => handleClick(e, link)}
    >
      {options && (
        <ul className={s.navMenu}>
          {menuOptions}
        </ul>
      )}
      <div className={s.link}>
        {menuIcon}
        {title.label && <span>{title.label}</span>}
      </div>
    </div>
  );
};

NavigationMenu.propTypes = {
  menuKey: PropTypes.string.isRequired,
  menuOpened: PropTypes.string,
  title: PropTypes.shape({
    icon: PropTypes.node,
    label: PropTypes.string
  }).isRequired,
  link: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.node,
    label: PropTypes.string.isRequired,
    link: PropTypes.string,
    fct: PropTypes.func,
    className: PropTypes.string
  })),
  handleMenu: PropTypes.func.isRequired
};

export default NavigationMenu;
